import { UseContextApp } from "../Global/Context/appContext";
import { actionTypes } from "../Global/actions/types";
import ServerCall from "./ServerCall";

const ConsumoController = () => {
  const [{ user }, dispatch] = UseContextApp();
  const consumoDetalles = async (input) => {
    var body = new FormData();
    body.append("docIdentidad", input.id);
    body.append("bPeriodoAnterior", input.status);
    const response = await ServerCall.post(
      `/Cliente/Consumo/Detalle`,
      body,
      user.token
    );
    return response;

  };

  const saldo = async (input) => {
    var body = new FormData();
    if (input.type !== "CI" && input.type !== "P") {body.append("docIdentidad", input.type + input.id);} 
    else {body.append("docIdentidad", input.id);}
    const response = await ServerCall.post(
      `/Cliente/Saldo`,
      body,
      user.token
    );
    return response;
  };


  const consumo = async (input) => {

      var body = new FormData();
      if (input.type !== "CI" && input.type !== "P") {body.append("docIdentidad", input.type + input.id);} 
      else {body.append("docIdentidad", input.id);}
      const response = await ServerCall.post(
        `/Cliente/Consumo`,
        body,
        input.token
      );
      if (localStorage.getItem("idToken")) {
        dispatch({ type: actionTypes.CONSUMO_DATE, payload: response });
      }
      return response;

  };

  const estadoCuenta = async (input) => {
      var body = new FormData();
      body.append("nroCuenta", input.nroCuenta);
      if (input.docType !== "CI" && input.docType !== "P") {body.append("docIdentidad", input.docType + input.docIdentidad);} 
      else {body.append("docIdentidad", input.docIdentidad);}
      const response = await ServerCall.post(
        `/Cliente/EdoCuenta`,
        body,
        user.token
      );
      return response;
  };

  const ctaFacturaCorpo = async (input) => {
      var body = new FormData();
      body.append("abonado", input?.datos?.ctaAbonado);
      body.append("docIdentidad", input?.datos?.docIdentificacion);
      const response = await ServerCall.post(
        `/Cliente/CtaFacturaCorpo`,
        body,
        user.token
      );
      return response;
  };

  const detalleTelefonia = async (input) => {
    var body = new FormData();
    body.append("idCustomerPO", input.idCustomerPO);
    body.append("fechaDesde", input.fechaDesde);
    body.append("fechaHasta", input.fechaHasta);
    const response = await ServerCall.post(
      `/Cliente/Telefonia`,
      body,
    );
    return response;
};
  return { consumo, saldo, consumoDetalles, estadoCuenta, ctaFacturaCorpo, detalleTelefonia };
};

export default ConsumoController;
